// Cribbed from https://code.amazon.com/packages/KatalMetricsSellerCentral/blobs/mainline/--/src/detectDomainRealm.ts

const SUBDOMAIN_REALM_MAP = {
    na: 'USAmazon',
    eu: 'EUAmazon',
    fe: 'FEAmazon',
    cn: 'CNAmazon',
};

// TLDs from https://code.amazon.com/packages/CSMInstrumentationJava/blobs/be9090bd7a67d05104f5f320c28949f8ad87260f/--/configuration/brazil-config/global/CSMInstrumentationJava.cfg#L121
const REALM_TLD_MAP = {
    USAmazon: ['ca', 'cl', 'com', 'com.br', 'com.co', 'com.mx'],
    EUAmazon: [
        'ae',
        'co.uk',
        'co.za',
        'com.be',
        'com.ng',
        'com.tr',
        'de',
        'eg',
        'es',
        'fr',
        'ie',
        'in',
        'it',
        'nl',
        'pl',
        'sa',
        'se',
    ],
    FEAmazon: ['co.jp', 'com.au', 'sg'],
    CNAmazon: ['cn'],
};

export default function detectDomainRealm() {
    const realm = detectRealmFromSurl();
    const domain = detectDomainFromSurl();

    return { domain, realm };
}

function detectDomainFromSurl() {
    // @ts-ignore
    const surl = window.ue_surl;
    if (surl) {
        if (surl.indexOf('nexusclient.prod') !== -1) {
            return 'prod';
        } else if (surl.indexOf('nexusclient.gamma') !== -1) {
            return 'test';
        }
    }
}

function detectRealmFromSurl() {
    // @ts-ignore
    const surl = window.ue_surl;
    if (surl) {
        const subdomain = surl.match(/unagi[-]([a-z]{2})/);
        if (subdomain) {
            return SUBDOMAIN_REALM_MAP[subdomain[1]];
        } else {
            const tld = surl.match(/unagi\.amazon\.([.a-z]{2,})\//);
            if (tld) {
                return Object.keys(REALM_TLD_MAP).find((realm) => REALM_TLD_MAP[realm].includes(tld[1]));
            }
        }
    }
}
